export default __webpack_public_path__ + "static/media/pay.8ec9a6a7.svg";